import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import CommentTransactionLayout from "../components/CommentTransactionLayout";
import * as actions from "../redux/actions/transactionRejectedActions";

class CommentTransactionRejected extends Component {
  componentDidMount() {
    this.fetchCommentList();
  }

  fetchCommentList = async () => {
    try {
      await this.props
        .LoadTransactionRejected(
          this.props.ad.UserStore.Id,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <CommentTransactionLayout
        variant="rejected"
        loading={this.props.loading}
        commentList={this.props.commentList}
        adId={this.props.ad?.Id}
      />
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,
    error: reducer.transactionRejected.error,
    loading: reducer.transactionRejected.loading,
    commentList: reducer.transactionRejected.list,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadTransactionRejected: (id, user_id, token) =>
    dispatch(actions.loadList({ id, user_id, token })),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CommentTransactionRejected)
);
